<template>
  <div
      class="my-3 col-lg-4 col-md-4 col-12"
  >
    <div>
      <label
          class="d-flex align-items-center my-1"
          :id="'date_' + field.id"
          :for="'date_' + field.id"
      >{{ field.fa_name }}
        <span v-if="field.status === fieldStatus.REQUIRED" class="text-danger">*</span>
      </label>
    </div>
    <datePicker
        color="#00c1a4"
        format="YYYY-MM-DD"
        :disabled="!customer_style"
        display-format="dddd jDD jMMMM jYYYY"
        input-class="form-control"
        :input-class="{'form-control light-input': customer_style}"
        clearable
        :id="'date-' + field.id"
        :name="'date-' + field.id"
        :placeholder="(field.details && field.details.find(i => i.type === 'placeholder'))
          ? field.details.find(i => i.type === 'placeholder').data
          : ''"
        type="date"
        v-model="field.value"
        @input="validateField"
    />
    <small v-show="field.error" class="text-danger text-tiny">این فیلد اجباری می باشد.</small>
  </div>
</template>

<script>
import { fieldOptionsConstants } from '@/constants/CustomerFormatFieldsOptions';

export default {
  name: 'DateInput',
  props: {
    field: {
      type: Object,
      required: true
    },
    customer_style: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    fieldStatus(){
      return fieldOptionsConstants
    },
  },
  methods: {
    validateField() {
      if (this.field.status === this.fieldStatus.REQUIRED && !this.field.value) {
        this.field.error = true
        this.$emit('validate', { fieldId: this.field.id, isValid: false })
      } else {
        this.field.error = false;
        this.$emit('validate', { fieldId: this.field.id, isValid: true });
      }
    }
  }
};
</script>

<style scoped>
.light-input, .light-input::placeholder {
  background-color: ghostwhite !important;
  color: gray !important;
  border-color: #8c8a8a !important;
}
</style>